module.exports = __webpack_public_path__ + "static/image 7_1-5fd39f8b3d6caae99a54c869728dcbea.png";